import React, { Component } from 'react'
import { DataTable } from '@softwaredev_cegeka/stix-data-table'
import './inlineDataTable.scss'

class InlineDataTable extends Component {
    render() {
        return (
            <DataTable
                className={'inline-data-table'}
                {...this.props}
                variant={'compact'}
            />
        )
    }
}

export default InlineDataTable
